import { useMutation, useQuery } from '@apollo/client';
import { Alert, message } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import classes from './OfficeTrips.module.scss';
import { pollIntensiveRequestVar } from '@/apollo/reactiveVars';
import BtnBlue from '@/atoms/BtnBlue/BtnBlue';
import BtnTransparent from '@/atoms/BtnTransparent/BtnTransparent';
import Preloader from '@/atoms/Preloader/Preloader';
import { getOfficeTripsDriverStatus } from '@/components/OfficeTrips/helpers/helpers';
import StationItem from '@/components/OfficeTrips/StationSelection/StationItem/StationItem';
import { unwrap } from '@/graphql/federation/unwrap';
import { LIST_TRIP_STATIONS, SET_STATUS_OFFLINE } from '@/graphql/officeTrips';
import useMeState from '@/hooks/useMeState';
import StatusIcon from '@/icons/status.svg';
import { routes } from '@/utils/constants';
import { getErrorMessage } from '@/utils/validateMessages';
const OfficeTrips = () => {
    var _a, _b, _c, _d;
    const intl = useIntl();
    const { meState } = useMeState();
    const { loading: loadingListStations, error: errorListStations, data: listStations } = useQuery(LIST_TRIP_STATIONS, {
        variables: {
            listTripStationsInput: {
                offset: 0,
                limit: 50
            }
        }
    });
    const [setStatusOffline] = useMutation(SET_STATUS_OFFLINE, {
        refetchQueries: () => [LIST_TRIP_STATIONS]
    });
    const setStatusOfflineForDriver = () => {
        setStatusOffline().then(() => {
            pollIntensiveRequestVar(true);
            void message.success(intl.formatMessage({ id: 'web.common.statusChanged', defaultMessage: 'Статус змінено' }), 3);
        }, (err) => { getErrorMessage(err, intl); });
    };
    const officeTripsStatus = (_a = meState === null || meState === void 0 ? void 0 : meState.officeTripsStatus) !== null && _a !== void 0 ? _a : null;
    const officeTripStationId = (_b = meState === null || meState === void 0 ? void 0 : meState.officeTripStationId) !== null && _b !== void 0 ? _b : null;
    const stationsResult = unwrap(listStations, 'officeTripsDBOStations');
    const getStationName = (_d = (_c = stationsResult === null || stationsResult === void 0 ? void 0 : stationsResult.listTripStations) === null || _c === void 0 ? void 0 : _c.items) === null || _d === void 0 ? void 0 : _d.find((station) => station.id === officeTripStationId);
    return (React.createElement("div", { className: classes.box },
        React.createElement("div", { className: classes.boxHead },
            React.createElement("div", { className: classes.boxTitle }, "Office Trips"),
            React.createElement(Link, { to: routes.officeTrips.f, className: classes.boxLink }, intl.formatMessage({ id: 'web.common.moreLink', defaultMessage: 'Більше' }))),
        meState && (React.createElement("div", { className: classes.holder },
            React.createElement("div", { className: classes.statusBox },
                React.createElement("div", { className: `${classes.status} ${officeTripsStatus !== 'OFFLINE' ? classes.statusActive : ''}` },
                    React.createElement(StatusIcon, null),
                    getOfficeTripsDriverStatus(officeTripsStatus !== null && officeTripsStatus !== void 0 ? officeTripsStatus : '', intl)),
                officeTripsStatus === 'WAITING_ORDER' && React.createElement(BtnTransparent, { onClick: setStatusOfflineForDriver, text: intl.formatMessage({ id: 'web.common.offline', defaultMessage: 'Офлайн' }) })),
            officeTripsStatus === 'OFFLINE' && (React.createElement("div", { className: classes.description }, intl.formatMessage({ id: 'web.officeTrips.waitingForOrderDescription', defaultMessage: 'Натисніть кнопку “Чекаю замовлення”, щоб мати можливість отримати поїздку' }))),
            officeTripsStatus === 'OFFLINE' && (React.createElement(Link, { state: { toggleStations: true }, to: routes.officeTrips.f, className: classes.link },
                React.createElement(BtnBlue, { fullWidth: true, high: true, text: intl.formatMessage({ id: 'web.officeTrips.waitingForOrder', defaultMessage: 'Чекаю замовлення' }) }))),
            officeTripsStatus === 'WAITING_ORDER' && (React.createElement(React.Fragment, null,
                errorListStations && React.createElement(Alert, { message: intl.formatMessage({ id: 'web.error.dataLoading', defaultMessage: 'Ошибка при загрузке данных' }), type: "error" }),
                loadingListStations && React.createElement(Preloader, { inner: true }),
                officeTripStationId && (React.createElement(StationItem, { station: {
                        id: officeTripStationId,
                        name: getStationName ? getStationName === null || getStationName === void 0 ? void 0 : getStationName.name : officeTripStationId,
                        driversCount: getStationName ? getStationName === null || getStationName === void 0 ? void 0 : getStationName.driversCount : '—',
                        address: getStationName ? getStationName === null || getStationName === void 0 ? void 0 : getStationName.address : '—'
                    } }))))))));
};
export default OfficeTrips;
